import { render, staticRenderFns } from "./KpiRealization.vue?vue&type=template&id=20081e62&"
import script from "./KpiRealization.vue?vue&type=script&lang=js&"
export * from "./KpiRealization.vue?vue&type=script&lang=js&"
import style0 from "./KpiRealization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports